module.exports = __webpack_public_path__ + "img/43_button.d61d5fd1.png";